import React from 'react';

import Top from './top.js';
import Bottom from './bottom.js';

import styles from '../styles.css';
/**
 * 右侧迎新统计数据板块
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-09-30 
 * Version: 1.0
 * Modify log:
 */
export default class IndexComponent extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
        }

    }

    render() {


        return (
            <div className={styles.rightBg}>
                <div className={styles.tableBox}>
                    <Top></Top>
                    <Bottom></Bottom>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/face/scan/rightBox/index.js